<template>
  <operation-panel
    v-if="normalizedReasons.length"
    :title="title"
    :subtitle="subtitle"
    tone="warning"
    :chip-label="chipLabel"
    chip-color="warning"
  >
    <div
      v-for="(reason, index) in normalizedReasons"
      :key="index"
      class="operation-blocked-reasons__item"
    >
      {{ reason }}
    </div>
  </operation-panel>
</template>

<script>
import OperationPanel from "./OperationPanel.vue";

export default {
  name: "OperationBlockedReasons",
  components: {
    OperationPanel,
  },
  props: {
    reasons: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "Kontrol Edin",
    },
    subtitle: {
      type: String,
      default: "Çözüm planını uygulayabilmeniz için kontrol edin.",
    },
    chipLabel: {
      type: String,
      default: "Kontrol",
    },
  },
  computed: {
    normalizedReasons() {
      return (this.reasons || [])
        .map((reason) => String(reason || "").trim())
        .filter(Boolean);
    },
  },
};
</script>

<style scoped>
.operation-blocked-reasons__item {
  color: #5f5f5f;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6;
}
</style>
